/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {IErrorObject} from "../../../../../types/platform/universe";

import {Component, ElementRef, Inject, OnInit, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthLevel} from "../../../../../types/aig/universe";
import {BaseDialogComponent} from "../../../platform/base/components/base-dialog.component";
import {TranslateService} from "@ngx-translate/core";
import {GuestsService} from "../guests.service";

import {Router} from "@angular/router";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-guest-dialog",
	styleUrls: ["./guest-dialog.component.css"],
	templateUrl: "./guest-dialog.component.html",
})

export class GuestDialogComponent extends BaseDialogComponent implements OnInit {

	@ViewChild('belongs_panel') belongsPanel: ElementRef;

	get user(): any {
		return this.data.user;
	}

	get content(): any {
		return this.data.content;
	}

	public type: string;

	public auths: any[] = [];

	public types: any[] = [
		{name: "管理", value: "manage"},
		{name: "企業", value: "company"},
		{name: "スタジオ", value: "studio"},
		{name: "トレーナー", value: "trainer"},
		{name: "一般", value: ""},
	];

	public auth: number;
	public account: any;
	public qr: string = "";
	public is2fa: boolean = false;
	public enable: boolean = false;

	/**
	 *
	 * @param data
	 * @param matDialogRef
	 * @param accountService
	 * @param router
	 * @param translate
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<GuestDialogComponent>,
		private accountService: GuestsService,
		private router: Router,
		public translate: TranslateService
	) {
		super();
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.is2Fa();
		this.auth = this.data.auth;
		this.account = this.data.user;

		const _auths: any[] = [
			{name: "system", value: AuthLevel.system},
			{name: "マネージャー", value: AuthLevel.manager},
			{name: "企業", value: AuthLevel.company},
			{name: "スタジオ", value: AuthLevel.studio},
			{name: "トレーナー", value: AuthLevel.trainer},
			{name: "一般", value: AuthLevel.user},
			{name: "その他", value: AuthLevel.public},
		];

		this.auths = _auths.filter((auth) => {
			return auth.value > this.auth;
		});

		this.content.gender = String(this.content.gender);
	}

	/**
	 * @returns none
	 */
	public cancel(): void {
		this.matDialogRef.close(null);
	}

	/**
	 * @returns none
	 */
	public onAccept(): void {
		this.content.gender = Number(this.content.gender);
		this.matDialogRef.close(this.data);
	}

	/**
	 * @returns none
	 */
	public is2Fa(): void {
		this.accountService.is_2fa(this.data.user.user_id, (error: IErrorObject, is2fa: any): void => {
			if (!error) {
				this.is2fa = is2fa;
			} else {

			}
		});
	}

	/**
	 * @returns none
	 */
	public onSet2Fa(): void {
		this.accountService.set_2fa(this.data.user.user_id, (error: IErrorObject, qr: any): void => {
			if (!error) {
				this.qr = qr;
				this.is2Fa();
			} else {

			}
		});
	}

	/**
	 * @returns none
	 */
	public onReset2Fa(): void {
		this.accountService.reset_2fa(this.data.user.user_id, (error: IErrorObject, result: any): void => {
			if (!error) {
				this.qr = "";
				this.is2Fa();
			} else {

			}
		});
	}

	/**
	 * @returns none
	 */
	public onProgressed(event: any): void {

	}

	/**
	 * @returns none
	 */
	public onUpdateAvatar(event: any): void {

	}

		/**
	 *
	 */
	public authIs(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.auth <= AuthLevel.system);
				break;
			case "manager":
				result = (this.auth <= AuthLevel.manager);
				break;
			case "company":
				result = (this.auth <= AuthLevel.company);
				break;
			case "studio":
				result = (this.auth <= AuthLevel.studio);
				break;
			case "trainer":
				result = (this.auth <= AuthLevel.trainer);
				break;
			case "user":
				result = (this.auth <= AuthLevel.user);
				break;
			case "public":
				result = (this.auth <= AuthLevel.public);
				break;
			default:
		}
		return result;
	}

		/**
	 *
	 */
	public accountAuthIs(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.account.auth === AuthLevel.system);
				break;
			case "manager":
				result = (this.account.auth === AuthLevel.manager);
				break;
			case "company":
				result = (this.account.auth === AuthLevel.company);
				break;
			case "studio":
				result = (this.account.auth === AuthLevel.studio);
				break;
			case "trainer":
				result = (this.account.auth === AuthLevel.trainer);
				break;
			case "user":
				result = (this.account.auth === AuthLevel.user);
				break;
			case "public":
				result = (this.account.auth === AuthLevel.public);
				break;
			default:
		}
		return result;
	}

			/**
	 *
	 */
	public accountTypeEq(type: string): boolean {
		return (this.account.type === type);
	}

	/**
	 *
	 */
	public onFix(): void {
		this.Progress(true);
		this.accountService.fix_parent(this.data.user.user_id, (error: IErrorObject, result: object[]) => {
			if (!error) {
			}
			this.Progress(false);
		});
	}

}
